import React, { useState, useEffect } from 'react';
import './index.css';
import profile from '../../assets/profile.PNG';
import { FaHome, FaUserTie, FaFileArchive, FaPhoneSquareAlt, FaCertificate  } from 'react-icons/fa';

export const Navbar = (props) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isDesktop = screenWidth >= 600;
  
  return (
    <>
      {isDesktop ? (
        <div className='container-desktop'>
          <div className="ImageArea">
            <div className="Profile">
              <div className="Image">
                <img src={profile} alt="Profile Picture" />
              </div>
            </div>
          </div>
          <div className='Buttons'>
          <button onClick={() => props.onNavItemClick(0) }>
              <FaHome style={{ marginRight: `5%` }} />
              Home
            </button>
            <button onClick={() => props.onNavItemClick(1) }>
              <FaUserTie style={{ marginRight: `5%` }} />
              About Me
            </button>
            <button onClick={() => props.onNavItemClick(2) }>
              <FaFileArchive style={{ marginRight: `5%` }} />
              Projects
            </button>
            <button onClick={() => props.onNavItemClick(3) }>
              <FaPhoneSquareAlt style={{ marginRight: `5%` }} />
              Contact
            </button>
            <button onClick={() => props.onNavItemClick(4) }>
              <FaCertificate  style={{ marginRight: `5%` }} />
              Certifications
            </button>
          </div>
          <div className="Footer">
            &copy; Abir Bhattacharya, 2024
          </div>
        </div>
      ) : (
        <div className="container-small">
          <button onClick={() => props.onNavItemClick(0) } style={{borderRight: '1px solid white'}}>
            <FaHome />
          </button>
          <button onClick={() => props.onNavItemClick(1) } style={{borderRight: '1px solid white'}}>
            <FaUserTie />
          </button>
          <button onClick={() => props.onNavItemClick(2) } style={{borderRight: '1px solid white'}}>
            <FaFileArchive />
          </button>
          <button onClick={() => props.onNavItemClick(3) }  style={{borderRight: '1px solid white'}}>
            <FaPhoneSquareAlt />
          </button>
          <button onClick={() => props.onNavItemClick(4) }>
            <FaCertificate  />
          </button>
        </div>
      )}
    </>
  );
};
